/* eslint-disable class-methods-use-this */
import {SocketLobbySend} from '../../../shared/scripts/socket/SocketLobbySend'
import {UIManagerEvents} from '../../../shared/scripts/ui_html/UIManagerEvents'
import {UIWAdController} from '../ui_ad/UIWAdController'
import {UIManager} from './UIManager'
import {Scene} from './UISceneTypes'
import {getHomepageUrlWithParameter, navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils'
import {UIUrlParameterNames} from '../../../shared/scripts/ui_html/UIUrlController'

export class UIWManagerEvents extends UIManagerEvents {
    protected readonly uiManager: UIManager | undefined

    constructor(uiManager: UIManager | undefined) {
        super()
        this.uiManager = uiManager
    }

    async createClickedJoinRoomCallback(gameId: string) {
        await UIWAdController.initiatePopupActionFromUserState(this.uiManager?.adController.adblockState.isAdblockActive ?? false)
        await SocketLobbySend.clickedJoinRoom(gameId)
    }

    isSceneLobby(): boolean {
        return this.uiManager?.sceneController.scene != Scene.Lobby
    }

    isSceneGame(): boolean {
        return this.uiManager?.sceneController.scene == Scene.Game
    }

    leaveRoomAndJoinRoom(roomId: string) {
        navigateToPage(`#${roomId}`, false)
    }

    handleUrlRedirectViaParameters(parameter: UIUrlParameterNames, parameterValue: any) {
        navigateToPage(getHomepageUrlWithParameter(parameter, parameterValue))
    }

    premiumMembershipCheckAction() {
        return () => {
            navigateToPage('/store#membership', true)
        }
    }

    shareImage(title: string, text: string, link: string, imageFile: File, imageSrc: string) {
        return
    }
}
